// @flow
// import dag1 from '../../../static/1-intervjudag-hjemme-til-jobb.json'
// import dag1_til_intervju from '../../../static/2-intervjudag-jobb-til-intervju.json'
// import dag1_til_intervju_2 from '../../../static/3-intervjudag-jobb-til-intervju.json'

export type Chapter = {
  title: string,
  text: string,
  mapbox: any
}

export const chapters: Array<Chapter> = [
  /*
  {
    gdocId: 'stavanger-oversikt',
    title: 'Onsdag 22. mai',
    text: '',
    fallbackPicture: '1.14306106',
    mapbox: {
      id: 'stavanger-oversikt',
      duration: 7000,
      center: [5.673073, 58.988715],
      // bounds: [[2, 40], [12, 65]],
      zoom: 10.5,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark'
    }
  },
  {
    gdocId: 'stavanger-oversikt',
    title: 'Stavanger',
    text: 'Han stod opp rundt kl. 05.57.',
    fallbackPicture: '1.14306106',
    mapbox: {
      id: 'stavanger-oversikt',
      duration: 7000,
      center: [5.673073, 58.978715],
      // bounds: [[2, 40], [12, 65]],
      zoom: 10,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark',
      point: {
        'name': 'navn3',
        'lat': 58.988715,
        'lon': 5.673073
      }
    }
  }, */
  {
    gdocId: 'stavanger-oversikt',
    title: 'Lørdag 22. juni',
    text: 'Dyreparken i Kristiansand',
    fallbackPicture: '1.15006984',
    mapbox: {
      id: 'stavanger-oversikt-linje',
      duration: 5000,
      center: [8.146217, 58.183351],
      // bounds: [[2, 40], [12, 65]],
      zoom: 17,
      pitch: 0,
      bearing: 20,
      mapColor: 'dark',
      // greatCircle: { name: 'benimambasa', data: dag1 },
      point: {
        name: 'navn3',
        lat: 58.891065,
        lon: 5.740115
      },
      showFocus: false
    }
  },
  {
    gdocId: 'en',
    title: 'kl. 10:25',
    text:
      'Dette er det første stedet NRK finner spor etter Karl inne i Dyreparken – utenfor Soko mat.',
    fallbackPicture: '1.15006986',
    textAlign: 'left',
    mapbox: {
      id: 'durban',
      duration: 5000,
      center: [8.14618, 58.18309],
      bearing: 0,
      zoom: 19,
      pitch: 15,
      showFocus: true
    }
  },
  {
    gdocId: 'to',
    title: 'kl. 11:57',
    text:
      'Litt senere så familien på apekatter i «Jungelen». Karl tok dette bildet, som NRK har fått i ettertid.',
    image:
      'https://static.nrk.no/dh/videos/beta/2020/dh-sporing/apekatt-dyreparken.jpg',
    alt: 'Bildet viser en apekatt på en gren.',
    fallbackPicture: '1.15006987',
    textAlign: 'left',
    mapbox: {
      id: 'tromso',
      duration: 5000,
      center: [8.14298, 58.18377],
      bearing: 0,
      zoom: 18,
      pitch: 0,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.933906,
        lon: 5.597758
      }
    }
  },
  {
    gdocId: 'start',
    title: 'kl. 14:39',
    text:
      'Familien gikk rundt i området «Båtbasaren» der det selges is og kioskvarer.',
    image:
      'https://static.nrk.no/dh/videos/beta/2020/dh-sporing/kiosk-dyreparken.jpg',
    alt: 'Bildet viser en kiosk i dyreparken i Kristiansand.',
    fallbackPicture: '1.15006989',
    textAlign: 'left',
    mapbox: {
      id: 'hentiesbay',
      duration: 5000,
      center: [8.14577, 58.18628],
      // bounds: [[2, 40], [12, 65]],
      zoom: 18,
      bearing: 20,
      pitch: 0,
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.891065,
        lon: 5.740115
      },
      pointCluster: {}
    }
  },
  {
    gdocId: 'tre',
    title: 'kl. 14:46',
    text:
      'Rundt sju minutter senere gikk de videre mot Kjuttaviga. Her pleier Kaptein Sabeltann å ha store show, men familien så ikke noen forestilling denne dagen.',
    fallbackPicture: '1.15006991',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 5000,
      center: [8.14538, 58.18596],
      bearing: 40,
      zoom: 18,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.18596,
        lon: 8.14538
      }
    }
  },
  {
    gdocId: 'tre',
    title: 'kl. 14:59',
    text:
      'De stoppet utenfor Laumanns lager, en av dyreparkens største souvenirbutikker. Her var de i rundt et kvarter, før de gikk videre.',
    fallbackPicture: '1.15006992',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 5000,
      center: [8.14356, 58.18552],
      bearing: 40,
      zoom: 18,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.922023,
        lon: 5.60279
      }
    }
  },
  /*
  {
    gdocId: 'tre',
    title: '14:46',
    text: 'De gikk innover her, og fant seg etter hvert et sted å spise.',
    fallbackPicture: '1.14306131',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 5000,
      center: [8.14282, 58.18627],
      bearing: 40,
      zoom: 18,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.18627,
        lon: 8.14282
      }
    }
  }, */
  {
    gdocId: 'tre',
    title: 'kl. 15:59',
    text:
      'En time senere var familien her, i «Nordisk villmark». De så på gauper, jerv, ulv, rev og elg.',
    image:
      'https://static.nrk.no/dh/videos/beta/2020/dh-sporing/gaupebilde.jpg',
    alt: 'Bildet viser en gaupe som ligger i gress.',
    fallbackPicture: '1.15006995',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 7000,
      center: [8.13519, 58.18612],
      bearing: 40,
      zoom: 18,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.922023,
        lon: 5.60279
      }
    }
  },
  {
    gdocId: 'start',
    title: 'kl. 18:15',
    text:
      'Til slutt gikk familien til bilen. Kort tid senere satte de kurs mot hytta.',
    fallbackPicture: '1.15006996',
    textAlign: 'left',
    mapbox: {
      id: 'hentiesbay',
      duration: 7000,
      center: [8.14996, 58.18488],
      // bounds: [[2, 40], [12, 65]],
      zoom: 18,
      bearing: 20,
      pitch: 0,
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.891065,
        lon: 5.740115
      },
      pointCluster: {}
    }
  }
]

export function createChapters (): Array<Chapter> {
  return chapters.map(chapter => {
    return { ...chapter }
  })
}



// WEBPACK FOOTER //
// ./src/v1/components/chapters.js